import { Calendar } from 'lucide-react';
import { DateRangePicker } from '../ui/date-range-picker';
import { cn } from '@/lib/utils';

interface ProfitabilityDateRangePickerProps {
  startDate: string;
  endDate: string;
  onStartDateChange: (value: string) => void;
  onEndDateChange: (value: string) => void;
  onReset?: () => void;
  resetLabel?: string;
  compact?: boolean;
  className?: string;
}

/**
 * Shared date-range controls for truth-layer profitability views.
 * Re-expressed on the canonical `DateRangePicker` — same API, the calendar
 * icon stays as decoration.
 */
export default function ProfitabilityDateRangePicker({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  onReset,
  resetLabel = 'Last 7 days',
  compact = false,
  className = '',
}: ProfitabilityDateRangePickerProps) {
  return (
    <div className={cn('flex flex-wrap items-center gap-2', className)}>
      <Calendar className={`${compact ? 'w-3.5 h-3.5' : 'w-4 h-4'} text-muted-foreground shrink-0`} />
      <DateRangePicker
        startDate={startDate}
        endDate={endDate}
        onStartDateChange={onStartDateChange}
        onEndDateChange={onEndDateChange}
        onReset={onReset}
        resetLabel={resetLabel}
        compact={compact}
        startLabel="Report start date"
        endLabel="Report end date"
      />
    </div>
  );
}
